import Persons from "./persons";

export default Persons;
